import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
import * as types from './mutation_types'

export const addComments = async ({ commit }, payload) => {
  try {
    let resp
    if (!payload.mode) {
      resp = await axios({ url: ENTRYPOINT + '/api/commentaire/ajout', data: payload.data, method: 'POST' })
    } else {
      resp = await axios({ url: ENTRYPOINT + '/invite/commentaire/ajout', data: payload.data, method: 'POST' })
    }
    commit(types.COMMENTS, resp.data.data)
  } catch (err) {
    console.log(err)
  }
}

export const modifyComments = async ({ commit }, payload) => {
  try {
    let resp
    if (!payload.mode) {
      resp = await axios({ url: ENTRYPOINT + '/api/commentaire/modification/' + payload.id, data: payload.data, method: 'POST' })
    } else {
      resp = await axios({ url: ENTRYPOINT + '/invite/commentaire/modification/' + payload.id, data: payload.data, method: 'POST' })
    }
    commit(types.COMMENTS, resp.data.data)
  } catch (err) {
    console.log(err)
  }
}

export const getComments = async ({ commit }, payload) => {
  try {
    let resp
    if (!payload.mode) {
      resp = await axios({ url: ENTRYPOINT + '/api/commentaire/liste/' + payload.type + '/' + payload.entity, method: 'GET' })
    } else {
      resp = await axios({ url: ENTRYPOINT + '/invite/commentaire/liste/' + payload.type + '/' + payload.entity, method: 'GET' })
    }
    commit(types.COMMENTS, resp.data.data)
  } catch (err) {
    console.log(err)
    if (payload.mode) {
      commit(types.IS_LOADED_ENTITY_ID, false)
    }
  }
}

export const deleteComment = async ({ commit }, data) => {
  try {
    let resp
    if (!data.mode) {
      resp = await axios({ url: ENTRYPOINT + '/api/commentaire/supprime/' + data.id, method: 'GET' })
    } else {
      resp = await axios({ url: ENTRYPOINT + '/invite/commentaire/supprime/' + data.id, method: 'GET' })
    }
    return resp.data.message
  } catch (err) {
  }
}

export const deleteAllComments = async ({ commit }, data) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/commentaire/supprime-tout/' + data.type + '/' + data.entity, method: 'DELETE' })
  } catch (err) {
    console.log(err)
  }
}

export const getNotifications = async ({ commit }) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/notification/liste', method: 'GET' })
    let count = resp.data.data.filter(item => item.etat === 1).length
    commit(types.NOTIFICATIONS, resp.data.data)
    commit(types.NOTIFICATIONS_COUNT, count)
  } catch (err) {
    console.log(err)
  }
}

export const setNotificationEtatVue = async ({ commit }, data) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/notification/etat-vue/' + data, data: {}, method: 'POST' })
  } catch (err) {
    console.log(err)
  }
}

export const deleteNotification = async ({ commit }, data) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/notification/supprime', data, method: 'DELETE' })
  } catch (err) {
    console.log(err)
  }
}

export const deleteAllNotifications = async ({ commit }) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/notification/supprime-tous', method: 'DELETE' })
  } catch (err) {
    console.log(err)
  }
}

export const setEntityId = ({ commit }, data) => {
  commit(types.SET_ENTITY_ID, data)
}

export const setIsLoadedEntityId = ({ commit }, data) => {
  commit(types.IS_LOADED_ENTITY_ID, data)
}

export const setIsLoadedComments = ({ commit }, data) => {
  commit(types.IS_LOADED_COMMENTS, data)
}

export const setLinkComment = ({ commit }, data) => {
  commit(types.NOTIF_LINK, data)
}

export const setIsFromNotif = ({ commit }, data) => {
  commit(types.IS_FROM_NOTIF, data)
}

// mode invite



// WEBPACK FOOTER //
// ./src/store/modules/comments/actions.js